import { render, staticRenderFns } from "./Nicknames-Single.vue?vue&type=template&id=3252f613&scoped=true"
import script from "./Nicknames-Single.js?vue&type=script&lang=js&external"
export * from "./Nicknames-Single.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3252f613",
  null
  
)

export default component.exports